module.exports = __webpack_public_path__ + "img/Luonan_Chen-500x500.89b5a907.jpg";